// APPLE Metrics
export const GA_SIWA_EMAIL_ALREADY_EXISTS = 'SIWA_AccountAlreadyExists';
export const GA_SIWA_ACCOUNTS_LINK_OPTION = 'SIWA_AccountsLinkOption';
export const GA_SIWA_ACCOUNT_CREATED = 'SIWA_AccountCreated';
export const GA_SIWA_ACCOUNT_CREATED_FAILED = 'SIWA_AccountCreatedFailed';
export const GA_APPLE_LOGIN_ACCOUNT_CREATED = 'AppleLogin_AccountCreated';
export const GA_APPLE_LOGIN_PERMISSIONS_NOT_GRANTED =
    'AppleLogin_PermissionsNotGranted';
export const GA_HIDDEN_EMAIL = 'hiddenEmail';
export const GA_SHOWED_EMAIL = 'showedEmail';

//FB Metrics
export const GA_FB_LOGIN_EMAIL_NOT_SHARED = 'FBLogin_EmailNotShared';
export const GA_FB_LOGIN_EXTERNAL_USER_UNKNOWN = 'FBLogin_ExternalUserUnknown';
export const GA_FB_LOGIN_LOGGED_IN_TO_FB = 'FBLogin_LoggedInToFB';
export const GA_FB_LOGIN_NO_EMAIL_ADDRESS = 'FBLogin_NoEmailAddress';
export const GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB = 'FBLogin_NotLoggedInToFB';
export const GA_FB_LOGIN_PERMISSIONS_GRANTED = 'FBLogin_PermissionsGranted';
export const GA_FB_LOGIN_ACCOUNT_CREATED = 'FBLogin_AccountCreated';
export const GA_FB_LOGIN_PERMISSIONS_NOT_GRANTED =
    'FBLogin_PermissionsNotGranted';

//Google Metrics
export const GA_GOOGLE_LOGIN_PERMISSIONS_GRANTED =
    'GoogleLogin_PermissionsGranted';
export const GA_GOOGLE_LOGIN_PERMISSIONS_NOT_GRANTED =
    'GoogleLogin_PermissionsNotGranted';
export const GA_GOOGLE_LOGIN_ACCOUNT_CREATED = 'GoogleLogin_AccountCreated';

//Google One Tap Metrics
export const GA_GOOGLE_ONE_TAP_TRIGGERED = 'OneTapLoginTriggered';
export const GA_GOOGLE_ONE_TAP_CLICKED = 'OneTapLoginClicked';
export const GA_GOOGLE_ONE_TAP_NOT_DISPLAYED = 'OneTapLoginNotDisplayed';
export const GA_GOOGLE_ONE_TAP_NOT_BLOCKED = 'OneTapLoginBlockedTemporarily';

//External links metrics
export const GA_COMMUNITY_GUIDELINES_CLICKED = 'CommunityGuidelinesClicked';
export const GA_PRIVACY_POLICY_CLICKED = 'PrivacyPolicyClicked';
export const GA_TERMS_OF_SERVICE_CLICKED = 'TermsOfServiceClicked';

//Reset password metrics
export const GA_PASSWORD_FORGOTTEN = 'PasswordForgotten';
export const GA_PASSWORD_FORGOTTEN_MAIL_FAILED = 'PasswordForgottenMailFailed';
export const GA_PASSWORD_FORGOTTEN_MAIL_SENT = 'PasswordForgottenMailSent';
export const GA_PASSWORD_INCORRECT = 'PasswordIncorrect';
export const GA_PASSWORD_VIEWED = 'PasswordViewed';
export const GA_RESET_PASSWORD_EMAIL_RETURN = 'ResetPasswordEmailReturn';
export const GA_SET_PASSWORD_EMAIL_RETURN = 'SetPasswordEmailReturn';
export const GA_FORGOT_PASSWORD_MODAL_OPEN = 'ForgotPasswordModalOpened';
export const GA_FORGOT_PASSWORD_MODAL_CLOSE = 'ForgotPasswordModalClosed';
export const GA_SET_PASSWORD_CLICKED = 'SetPasswordClicked';
export const GA_RESET_PASSWORD_CLICKED = 'ResetPasswordClicked';

//Magic Link Metrics
export const GA_MAGIC_LINK_CLICKED = 'MagicLinkClicked';
export const GA_MAGIC_LINK_CONFIRMATION_CLOSED = 'MagicLinkConfirmationClosed';
export const GA_MAGIC_LINK_FAILED = 'MagicLinkFailed';
export const GA_MAGIC_LINK_SENT = 'MagicLinkSent';
export const GA_ACCOUNT_LINK_CONFIRMATION_CLOSED =
    'AccountLinkConfirmationClosed';
export const GA_ACCOUNT_LINK_FAILED = 'AccountLinkFailed';
export const GA_ACCOUNT_LINKED = 'AccountLinked';
export const GA_ACCOUNT_LOGIN_NOT_LINKED = 'LoginNotLinkedSuccessful';

//Soft account Metrics
export const GA_SOFT_ACCOUNT_MAIL_FAILED = 'SoftAccountMailFailed';
export const GA_SOFT_ACCOUNT_MAIL_SENT = 'SoftAccountMailSent';

//Passwordless Metrics
export const GA_PASSWORDLESS_EMAIL_MODAL_OPEN = 'PasswordlessClicked';
export const GA_PASSWORDLESS_EMAIL_MODAL_CLOSE = 'PasswordlessClosed';
export const GA_PASSWORDLESS_EMAIL_ATTEMPT = 'PasswordlessSendLink';
export const GA_PASSWORDLESS_EMAIL_FAILED = 'PasswordlessEmailFailed';
export const GA_PASSWORDLESS_EMAIL_SENT = 'PasswordlessEmailSent';
export const GA_PASSWORDLESS_LOGIN_FAILED = 'PasswordlessLoginFailed';
export const GA_PASSWORDLESS_SET_PASSWORD_FAILED =
    'PasswordlessSetPasswordFailed';
export const GA_PASSWORDLESS_EMAIL_RETURN = 'PasswordlessEmailReturn';
export const GA_PASSWORDLESS_SUCCESS = 'PasswordlessSuccess';
export const GA_PASSWORDLESS_CONTINUE_CLICK = 'ContinueWithoutPasswordClicked';
export const GA_PASSWORDLESS_SET_PASSWORD_CLICK = 'SetPasswordClicked';
export const GA_PASSWORDLESS_SET_PASSWORD_SUCCESS = 'SetPasswordlessSuccess';

// ToS Metrics
export const TOSMODAL_NEWACCOUNT_SHOWED = 'ToSModal_NewAccount_Showed';
export const TOSMODAL_NEWACCOUNT_DENIED = 'ToSModal_NewAccount_Denied';
export const TOSMODAL_NEWACCOUNT_ACCEPTED = 'ToSModal_NewAccount_Accepted';
export const TOSMODAL_SET_PASSWORD_SHOWED = 'ToSModal_SoftAccount_Showed';
export const TOSMODAL_SET_PASSWORD_DENIED = 'ToSModal_SoftAccount_Denied';
export const TOSMODAL_SET_PASSWORD_ACCEPTED = 'ToSModal_SoftAccount_Accepted';
export const TOSMODAL_SOCIAL_SHOWED = 'ToSModal_Social_Showed';
export const TOSMODAL_SOCIAL_DENIED = 'ToSModal_Social_Denied';
export const TOSMODAL_SOCIAL_ACCEPTED = 'ToSModal_Social_Accepted';
export const TOSMODAL_PASSWORDLESS_SHOWED = 'ToSModal_Passwordless_Showed';
export const TOSMODAL_PASSWORDLESS_DENIED = 'ToSModal_Passwordless_Denied';
export const TOSMODAL_PASSWORDLESS_ACCEPTED = 'ToSModal_Passwordless_Accepted';

//Login/Signup Metrics
export const GA_CONTINUE_CREATE_ACCOUNT_CLICKED =
    'ContinueCreateAccountClicked';
export const GA_CONTINUE_CREATE_ACCOUNT_EXISTS = 'ContinueCreateAccountExists';
export const GA_CONTINUE_CREATE_ACCOUNT_NEW = 'ContinueCreateAccountNew';
export const GA_LOGIN_CATEGORY = 'Login';
export const GA_LOGIN_CLICKED = 'LoginClicked';
export const GA_LOGIN_EVENT = 'Login';
export const GA_LOGIN_SUCCESSFUL = 'LoginSuccessful';
export const GA_LOGIN_SUCCESSONESTEP = 'LoginSuccessOneStep';

//Other Metrics
export const GA_EMAIL_NOT_FOUND = 'EmailNotFound';
export const GA_LINK_ACCOUNT_OPTION = 'linkAccountOption';
export const GA_TOKEN_EXPIRED = 'tokenExpired';
export const GA_SESSION_EXPIRED = 'sessionExpired';
export const GA_AUTH_CHECKOUT_CATEGORY = 'signinCheckout';
export const GA_CHECK_EMAIL_PROMPT_EVENT = 'CheckEmailPrompt';
export const GA_CONFIRM_EMAIL_SHOWED = 'ReEnterEmail';
export const GA_CONFIRMATION_ACKNOWLEDGED = 'SignInConfirmationAcknowledged';
export const GA_CONFIRMATION_REJECTED = 'SignInConfirmationRejected';
export const GA_EDIT_EMAIL_EVENT = 'EmailEdited';
export const GA_EDIT_EMAIL_MISMATCH = 'EditEmailMismatch';
export const GA_ENTER_EMAIL_EVENT = 'EnterEmail';
export const GA_EXISTING_ACCT_LABEL = 'existing account';
export const GA_LINK_ACCOUNTS_LOGIN_EVENT = 'LinkAccountsLogin';
export const GA_LOGIN_INSTEAD_CLICKED_EVENT = 'ClickLoginInstead';
export const GA_LOGIN_INVALID_EMAIL = 'LoginInvalidEmail';
export const GA_NEW_ACCT_LABEL = 'new account';
export const GA_RE_ENTER_EMAIL_LABEL = 'Re-enter email';
export const GA_RESET_PASSWORD_EVENT = 'ResetPassword';
export const GA_SET_PASSWORD_EVENT = 'SetPassword';
export const GA_SIGNUP_CLICKED = 'SignUpClicked';
export const GA_SIGNUP_EVENT = 'Signup';
export const GA_SOCIAL_LOGIN_ACCOUNT_LINKING_FAILED =
    'SocialLogin_AccountLinkingFailed';
export const GA_SOCIAL_LOGIN_EMAIL_ALREADY_EXISTS =
    'SocialLogin_EmailAlreadyExists';
export const GA_SOCIAL_SIGNUP_EVENT = 'SocialSignUp';
export const GA_SOCIAL_SOFT_ACCOUNT_EXISTS = 'SocialSoftAccountExists';
export const GA_SOFT_ACCT_LABEL = 'soft account';
export const GA_USE_ANOTHER_ACCOUNT_CLICKED = 'UseAnotherAccountClicked';
export const GA_ACCOUNT_AUTOLINKED = 'AccountAutoLinked';
export const GA_HANDLE_ON_ERROR = 'HandleOnError';
export const GA_STAFF_USER_NOT_ALLOWED = 'StaffUserNotAllowed';
export const GA_SAVE_PASSWORD_CLICKED = 'SavePasswordClicked';

// SourceProvider Social
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB =
    'GetStarted_AlreadyConnectedToFB';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE =
    'GetStarted_AlreadyConnectedToApple';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_GOOGLE =
    'GetStarted_AlreadyConnectedToGoogle';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_FB =
    'GetStarted_AlreadyConnectedToAppleAndFacebook';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_GOOGLE =
    'GetStarted_AlreadyConnectedToAppleAndGoogle';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB_GOOGLE =
    'GetStarted_AlreadyConnectedToFBAndGoogle';
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_GOOGLE_FACEBOOK =
    'GetStarted_AlreadyConnectedToAppleGoogleAndFB';

// Social labels are left lowercased to maintain a consistent logic throughout the platform, they get capitalized when sent as labels for gaTracking
export const GA_EVENTBRITE = 'Eventbrite';
export const GA_FACEBOOK = 'facebook';
export const GA_APPLE = 'apple';
export const GA_GOOGLE = 'google';
export const GA_PASSWORDLESS = 'Passwordless';
export const GA_ALL_SOCIALS = [GA_FACEBOOK, GA_APPLE, GA_GOOGLE];

export const GA_SOCIAL_ACCOUNT_CREATED = {
    facebook: GA_FB_LOGIN_ACCOUNT_CREATED,
    apple: GA_APPLE_LOGIN_ACCOUNT_CREATED,
    google: GA_GOOGLE_LOGIN_ACCOUNT_CREATED,
};

export const GA_SOCIAL_PERMISSIONS_GRANTED = {
    facebook: GA_FB_LOGIN_PERMISSIONS_GRANTED,
    apple: 'Apple permissions granted',
    google: GA_GOOGLE_LOGIN_PERMISSIONS_GRANTED,
};

export const GA_SOCIAL_PERMISSIONS_NOT_GRANTED = {
    facebook: GA_FB_LOGIN_PERMISSIONS_NOT_GRANTED,
    apple: GA_APPLE_LOGIN_PERMISSIONS_NOT_GRANTED,
    google: GA_GOOGLE_LOGIN_PERMISSIONS_NOT_GRANTED,
};

// Hierarchy order for Socials: Facebook -> Apple -> Google -> Future Social
export const GA_GET_STARTED_EMAIL_ALREADY_CONNECTED = {
    [GA_FACEBOOK]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB,
    [GA_APPLE]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE,
    [GA_GOOGLE]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_GOOGLE,
    [`${GA_FACEBOOK}${GA_APPLE}`]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_FB,
    [`${GA_FACEBOOK}${GA_GOOGLE}`]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB_GOOGLE,
    [`${GA_APPLE}${GA_GOOGLE}`]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_GOOGLE,
    [`${GA_FACEBOOK}${GA_APPLE}${GA_GOOGLE}`]: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_GOOGLE_FACEBOOK,
};
